import { ForecastBase } from './base/forecast-base';

export class Forecast extends ForecastBase { }